'use client';

import { CustomButton } from '@/components/ui/CustomButton';
import React from 'react';
import Link from 'next/link';
import { Info } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { Tooltip } from 'react-tooltip';
import { ADVISER_PORTAL } from '@/constant/external-links';

export const SidebarTemplate = () => {
  const router = useRouter();

  return (
    <div className="hidden lg:block mt-6">
      <div className="sticky top-4">
        <p className="text-xl font-semibold mb-6">Get started</p>
        <nav className="space-y-4">
          <div>
            <p className="text-xl font-medium text-[#373945] mb-4">Key documents</p>
            <a href="#product-documents" className="text-[#5B5D6B] text-lg font-medium hover:underline cursor-pointer pl-2 inline-block mb-4">
              Product documents
            </a>
            <a href="#application-documents" className="text-[#5B5D6B] text-lg font-medium hover:underline cursor-pointer pl-2 inline-block mb-4">
              Application documents
            </a>
            <a href="#general-documents" className="text-[#5B5D6B] text-lg font-medium hover:underline cursor-pointer pl-2 inline-block">
              General documents
            </a>
          </div>
          <div>
            <div className="mt-6 mb-6">
              <a href="#loan" className="text-xl font-medium text-[#373945] hover:underline cursor-pointer">
                Loans
              </a>
            </div>
            <div className="mb-6">
              <a href="#product-features" className="text-xl font-medium text-[#373945] hover:underline cursor-pointer">
                Features
              </a>
            </div>
            <div className="mb-6">
              <div className="flex items-center gap-2">
                <a
                  href={ADVISER_PORTAL.LOGIN}
                  className="text-xl font-medium text-[#373945] hover:underline cursor-pointer"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  Ask Lenny
                </a>
                <Tooltip className="tooltip" id="ask-lenny-tooltip" opacity={5} offset={0} />
                <span
                  className="inline-flex"
                  data-mega-menu-tail
                  data-tooltip-id="ask-lenny-tooltip"
                  data-tooltip-content="Get instant answers on lending criteria with Lenny, our AI-driven assistant."
                >
                  <Info
                    size={25}
                    className="text-[#006EB7] fill-[#006EB7]/[0.12] cursor-pointer"
                  />
                </span>
              </div>
            </div>
          </div>
          <CustomButton
            variant="primaryMedium"
            className="w-auto"
            onClick={() => router.push(ADVISER_PORTAL.CREATE_KFI, '_blank')}
          >
            Create KFI
          </CustomButton>
        </nav>
      </div>
    </div>
  );
};
